import axios from "axios";
import { getAccessTokenSilently } from "@/auth";

const BASE_URL = "https://billing.clafoutis.eu/api";

export const INVENTORY_STATUSES = [
  { id: "en_stock", label: "En stock" },
  { id: "en_service", label: "En service" },
  { id: "vendu", label: "Vendu" },
  { id: "rebut", label: "Rebut" },
  { id: "perdu", label: "Perdu / cassé" },
];

export function inventoryStatusLabel(id) {
  const status = INVENTORY_STATUSES.find((s) => s.id === id);
  return status ? status.label : id;
}

export function useInventoryService() {

  async function client() {
    const token = await getAccessTokenSilently();
    return axios.create({ baseURL: BASE_URL, headers: { Authorization: `Bearer ${token}` } });
  }

  return {
    async list(params = {}) {
      return (await (await client()).get("/inventory", { params })).data;
    },
    async byInvoice(invoiceId) {
      return (await (await client()).get(`/inventory/invoice/${invoiceId}`)).data;
    },
    async create(payload) {
      return (await (await client()).post("/inventory", payload)).data;
    },
    async update(id, payload) {
      return (await (await client()).patch(`/inventory/${id}`, payload)).data;
    },
    async remove(id) {
      return (await (await client()).delete(`/inventory/${id}`)).data;
    },
    async listCompanies() {
      const { data } = await (await client()).get("/company");
      return data.companys || [];
    },
  };
}
